import React from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { Creators as actions } from '../../redux/actions';
import MaskedInput from 'react-text-mask';
import debounce from 'lodash/debounce';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';

import {
    getCashPurchaseOption,
    getMoneyFormatter,
    getCashPurchaseToPay,
    getFinanceOptions,
    getMetaFinancePlans,
    getSelectedFinancePlan,
    getSelectedFinanceOptions,
    getHasTaxesIncluded,
    getPaymentOptions
} from '../../redux/selectors';

import { t, l } from 'react-i18nify';
import GetTradeinEstimate from "../GetTradeinEstimate";

const CashPurchaseForm = () => {
    const dispatch = useDispatch()
    const cashPurchaseOption = useSelector(getCashPurchaseOption)
    const paymentOptions = useSelector(getPaymentOptions);
    const formatAsMoney = useSelector(getMoneyFormatter)
    // deposit: getCashPurchaseDeposit(state),
    // toPay: getCashPurchaseToPay(state),
    const { transaction = [] } = cashPurchaseOption;
    const { lien, tradeIn, vehicleCondition } = paymentOptions || {};
    const base = transaction.find(item => item.category === 'base') || {};
    const taxes = transaction.find(item => item.category === 'tax') || {};
    const toPay = transaction.find(item => item.category === 'toPay') || {};
    const options = transaction.find(item => item.category === 'option') || {};
    const protections = transaction.find(item => item.category === 'protection') || {};
    const sellingPrice = transaction.find(item => item.category === 'total') || {};
    const discount = transaction.find(item => item.category === 'discount') || {};
    const rebate = transaction.find(item => item.category === 'rebate') || {};

    const defaultMaskOptions = {
        prefix: '$ ',
        suffix: '',
        includeThousandsSeparator: true,
        thousandsSeparatorSymbol: ',',
        allowDecimal: true,
        decimalSymbol: '.',
        decimalLimit: 2, // how many digits allowed after the decimal
        integerLimit: 7, // limit length of integer numbers
        allowNegative: false,
        allowLeadingZeroes: false,
    };

    const currencyMask = createNumberMask(defaultMaskOptions);
    const onChangeTradeInAmount = debounce(value => dispatch(actions.changeTradeInAmount(value.replace(/[$,]+/g,""))), 400)
    const onChangeLienAmount = debounce(value => dispatch(actions.changeLienAmount(value.replace(/[$,]+/g,""))), 400)

    return (
        <div className="tabs-panel vehicle-payment-tabs__content is-active">
            <div className="vehicle-payment-tabs__content-item">
                <div className="calculator-popup-table-cashdown">
                    <div className="calculator-popup-table-cashdown__elem">
                        <div className="calculator-popup-table-cashdown__item text-bold">
                            <span className="calculator-popup-table-cashdown__item-label calculator-popup-table-cashdown__item-label--bigger">{t('wasAt')}</span>
                            <span className="calculator-popup-table-cashdown__item-value calculator-popup-table-cashdown__item-value--bigger">{formatAsMoney(base.amount)}</span>
                        </div>
                        {
                            base.items && base.items.map(item => (
                                <div className="calculator-popup-table-cashdown__item calculator-popup-table-cashdown__item--padding-left" data-theme-style="smallprint">
                                    <span className="calculator-popup-table-cashdown__item-label">{(item.description == 'MSRP' || item.description == 'PDSF') && vehicleCondition.includes('used') ? t('price') : item.description}</span>
                                    <span className="calculator-popup-table-cashdown__item-value">{formatAsMoney(item.amount)}</span>
                                </div>
                            ))
                        }
                    </div>
                    <div className="calculator-popup-table-cashdown__elem">
                        <div className="calculator-popup-table-cashdown__item" data-theme-style="vehicleCashPurchase_incentivesValue_fontColor">
                            <span className="calculator-popup-table-cashdown__item-label">
                                <i className="calculator-popup-table-cashdown__item-picto" data-theme-sprite="rebate"></i>{discount.name} ({t('beforeTax')})
                            </span>
                            <span className="calculator-popup-table-cashdown__item-value">{formatAsMoney(discount.amount)}</span>
                        </div>
                    </div>
                    <div className="calculator-popup-table-cashdown__elem">
                        <div className="calculator-popup-table-cashdown__item">
                            <span className="calculator-popup-table-cashdown__item-label">{options.name}</span>
                            <span className="calculator-popup-table-cashdown__item-value">{formatAsMoney(options.amount)}</span>
                        </div>
                        <div className="calculator-popup-table-cashdown__item">
                            <span className="calculator-popup-table-cashdown__item-label">{protections.name}</span>
                            <span className="calculator-popup-table-cashdown__item-value">{formatAsMoney(protections.amount)}</span>
                        </div>
                        <div className="calculator-popup-table-cashdown__item text-bold">
                            <span className="calculator-popup-table-cashdown__item-label calculator-popup-table-cashdown__item-label--bigger">{sellingPrice.name}</span>
                            <span className="calculator-popup-table-cashdown__item-value calculator-popup-table-cashdown__item-value--bigger">{formatAsMoney(sellingPrice.amount)}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div className="vehicle-payment-tabs__content-item">
                <div className="calculator-popup-table-cashdown">
                    <div className="calculator-popup-table-cashdown__elem">
                        <div className="calculator-popup-table-cashdown__item calculator-popup-table-cashdown__item--margin-bottom">
                            <span className="calculator-popup-table-cashdown__item-label calculator-popup-table-cashdown__item-label--bigger text-bold">{t('totalObligation')}</span>
                        </div>
                        <div className="calculator-popup-table-cashdown__item text-bold">
                            <span className="calculator-popup-table-cashdown__item-label calculator-popup-table-cashdown__item-label--bigger">{sellingPrice.name}</span>
                            <span className="calculator-popup-table-cashdown__item-value calculator-popup-table-cashdown__item-value--bigger">{formatAsMoney(sellingPrice.amount)}</span>
                        </div>
                        <div className="calculator-popup-table-cashdown__item calculator-popup-table-cashdown__item--border-bottom">
                            <span className="calculator-popup-table-cashdown__item-label" data-theme-style="vehicleCashPurchase_incentivesValue_fontColor">{t('tradeInLabel')}</span>
                            <span className="calculator-popup-table-cashdown__item-value">
                                <MaskedInput
                                    defaultValue={tradeIn > 0 ? tradeIn : ''}
                                    mask={currencyMask}
                                    className="input-number"
                                    placeholder="$ 0"
                                    type="text"
                                    onChange={e => onChangeTradeInAmount(e.target.value)}
                                />
                            </span>
                        </div>
                        <div className="calculator-popup-table-cashdown__item calculator-popup-table-cashdown__item--link">
                            <GetTradeinEstimate />
                        </div>
                        <div className="calculator-popup-table-cashdown__item">
                            <span className="calculator-popup-table-cashdown__item-label">{taxes.name}</span>
                            <span className="calculator-popup-table-cashdown__item-value">{formatAsMoney(taxes.amount)}</span>
                        </div>
                        {
                            taxes.items && taxes.items.map(item => (
                                <div className="calculator-popup-table-cashdown__item calculator-popup-table-cashdown__item--padding-left" data-theme-style="smallprint">
                                    <span className="calculator-popup-table-cashdown__item-label">{item.description}</span>
                                    <span className="calculator-popup-table-cashdown__item-value">{formatAsMoney(item.amount)}</span>
                                </div>
                            ))
                        }
                        <div className="calculator-popup-table-cashdown__item calculator-popup-table-cashdown__item--border-bottom">
                            <span className="calculator-popup-table-cashdown__item-label">{t('lienLabel')}</span>
                            <span className="calculator-popup-table-cashdown__item-value">
                                <MaskedInput
                                    defaultValue={lien > 0 ? lien : ''}
                                    mask={currencyMask}
                                    className="input-number"
                                    placeholder="$ 0"
                                    type="text"
                                    onChange={e => onChangeLienAmount(e.target.value)}
                                />
                            </span>
                        </div>
                        <div className="calculator-popup-table-cashdown__item" data-theme-style="vehicleCashPurchase_incentivesValue_fontColor">
                            <span className="calculator-popup-table-cashdown__item-label">
                                <i className="calculator-popup-table-cashdown__item-picto" data-theme-sprite="rebate"></i>{rebate.name} ({t('afterTax')})
                            </span>
                            <span className="calculator-popup-table-cashdown__item-value">{formatAsMoney(rebate.amount)}</span>
                        </div>
                        <div className="calculator-popup-table-cashdown__item text-bold">
                            <span className="calculator-popup-table-cashdown__item-label calculator-popup-table-cashdown__item-label--bigger">{toPay.name}</span>
                            <span className="calculator-popup-table-cashdown__item-value calculator-popup-table-cashdown__item-value--bigger">{formatAsMoney(toPay.amount)}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default CashPurchaseForm